import { render } from "./NewsUpdate.vue?vue&type=template&id=48701f52&scoped=true"
import script from "./NewsUpdate.vue?vue&type=script&lang=js"
export * from "./NewsUpdate.vue?vue&type=script&lang=js"

import "./NewsUpdate.vue?vue&type=style&index=0&id=48701f52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48701f52"]])

export default __exports__